module.exports = __webpack_public_path__ + "static/img/um.030e7e0b.svg";